/* global axios */
import ApiClient from '../ApiClient';

// Prime Insight — "+ Recursos": external integrations (Google Calendar/Gmail/ClickUp...)
// with per-user credentials and dedicated resource-type AI agents.
class MetricaResourcesAPI extends ApiClient {
  constructor() {
    super('metrica', { accountScoped: true });
  }

  // Connections (personal — every user manages their OWN).
  catalog() {
    return axios.get(`${this.url}/resource_connections/catalog`);
  }

  connections() {
    return axios.get(`${this.url}/resource_connections`);
  }

  team() {
    return axios.get(`${this.url}/resource_connections/team`);
  }

  connect(payload) {
    return axios.post(`${this.url}/resource_connections`, {
      resource_connection: payload,
    });
  }

  authorizeUrl(provider) {
    return axios.post(`${this.url}/resource_connections/authorize_url`, {
      provider,
    });
  }

  disconnect(id) {
    return axios.delete(`${this.url}/resource_connections/${id}`);
  }

  // Agents (admin-only, governs prompt/tools/cost).
  agents() {
    return axios.get(`${this.url}/resource_agents`);
  }

  createAgent(payload) {
    return axios.post(`${this.url}/resource_agents`, {
      resource_agent: payload,
    });
  }

  updateAgent(id, payload) {
    return axios.patch(`${this.url}/resource_agents/${id}`, {
      resource_agent: payload,
    });
  }

  deleteAgent(id) {
    return axios.delete(`${this.url}/resource_agents/${id}`);
  }

  testAgent(id, instruction) {
    return axios.post(`${this.url}/resource_agents/${id}/test_message`, {
      instruction,
    });
  }

  // Individual capabilities (name + description) a provider offers, for the
  // "Capacidades da integração" per-tool toggle UI.
  toolCatalog(provider) {
    return axios.get(`${this.url}/resource_agents/tool_catalog`, {
      params: { provider },
    });
  }

  // History.
  logs(params = {}) {
    return axios.get(`${this.url}/resource_logs`, { params });
  }

  // Vertical hotelaria: property config (Bukly/Omnibees) — per ACCOUNT, not
  // per-user, admin-only. See memory: metrica-hotel.
  hotelProperties() {
    return axios.get(`${this.url}/hotel_properties`);
  }

  createHotelProperty(payload) {
    return axios.post(`${this.url}/hotel_properties`, {
      hotel_property: payload,
    });
  }

  updateHotelProperty(id, payload) {
    return axios.patch(`${this.url}/hotel_properties/${id}`, {
      hotel_property: payload,
    });
  }

  deleteHotelProperty(id) {
    return axios.delete(`${this.url}/hotel_properties/${id}`);
  }

  // Vertical turismo receptivo: loja Paytour config — per ACCOUNT, not
  // per-user, admin-only. Passeios are auto-discovered (never typed manually),
  // see PaytourCatalogSync. See memory: metrica-resources.
  paytourStores() {
    return axios.get(`${this.url}/paytour_stores`);
  }

  createPaytourStore(payload) {
    return axios.post(`${this.url}/paytour_stores`, {
      paytour_store: payload,
    });
  }

  updatePaytourStore(id, payload) {
    return axios.patch(`${this.url}/paytour_stores/${id}`, {
      paytour_store: payload,
    });
  }

  deletePaytourStore(id) {
    return axios.delete(`${this.url}/paytour_stores/${id}`);
  }

  syncPaytourStore(id) {
    return axios.post(`${this.url}/paytour_stores/${id}/sync`);
  }
}

export default new MetricaResourcesAPI();
